import mediaQueries from '../constants/mediaQueries'

/**
 * Return the styles object with the media query as a key and the styles defined as a value.
 * @param {string} mediaQuery - The media query (sm, md or lg).
 * @param {Object} styles - The object with the styles.
 */
export function responsiveStyles(mediaQuery = null, styles) {
	if (mediaQuery && !mediaQueries[mediaQuery]) {
		return {}
	}

	if (mediaQuery && mediaQuery !== 'sm') {
		return {
			[`@media screen and (min-width: ${mediaQueries[mediaQuery].min}px)`]: styles
		}
	}

	return styles
}

/**
 * Return the styles object with the media query, but as independent elements
 * so it could be easily access for dynamic JSS styles assignment
 * @param {string} mediaQuery - The media query (sm, md or lg).
 * @param {Object} styles - The object with the styles.
 */
export function responsiveDinamicStyles(mediaQuery = null, styles) {
	if (mediaQuery && !mediaQueries[mediaQuery]) {
		return {}
	}

	if (mediaQuery && mediaQuery !== 'sm') {
		return {
			mediaQkey: [`@media screen and (min-width: ${mediaQueries[mediaQuery].min}px)`],
			stylesVal: styles
		}
	}

	return styles
}
